import request from '@/api/request.js'

// // 查询数据源列表 
// export function domainList(data) {
//     return request({
//         url: 'api/wudaogang/domain/list',
//         method: 'post',
//         data
//     })
// }

// // 开始结束状态修改 
// export function domainAction(data) {
//     return request({
//         url: 'api/wudaogang/domain/action',
//         method: 'post',
//         data
//     })
// }

// // 修改数据源
// export function domainUpdate(data) {
//     return request({
//         url: 'api/wudaogang/domain/update',
//         method: 'post',
//         data
//     })
// }

// // 修改数据源
// export function domainAdd(data) {
//     return request({
//         url: 'api/wudaogang/domain/add',
//         method: 'post',
//         data
//     })
// }

// 修改数据源
// export function domainSearch(code) {
//     return request({
//         url: `api/wudaogang/domain/search/${code}`,
//         method: 'get'
//     })
// }

// // 删除数据源
// export function domainDelete(id,orgId) {
//     return request({
//         url: `api/wudaogang/domain/delete/${id}/${orgId}`,
//         method: 'DELETE'
//     })
// }

//传送接口过去
export function domainSend(data) {
  return request({
    url: `api/wudaogang/domain/addUser`,
    method: 'post',
    data
  })
}

export function domainList(data) {
  return request({
    url: `api/wudaogang/domain/list`,
    method: 'post',
    data
  })
}

// 查询数据源列表 
export function domainSearch(code) {
  return request({
    url: `api/wudaogang/domain/search/${code}`,
    method: 'get',
  })
}

//获取模板
export function listInsert(data) {
  return request({
    url: `api/wudaogang/domain/templateList`,
    method: 'post',
    data: data,
  })
}

//新增数据
export function domainAdd(data) {
  return request({
    url: `api/wudaogang/domain/add`,
    method: 'post',
    data
  })
}
//编辑数据
export function domainUpdate(data) {
  return request({
    url: `api/wudaogang/domain/update`,
    method: 'post',
    data
  })
}

//批量静音
export function batchUpdate(data) {
  return request({
    url: `api/wudaogang/domain/batchUpdate`,
    method: 'post',
    data
  })
}

//运行暂停/继续
export function domainRun(data) {
  return request({
    url: `api/wudaogang/domain/run`,
    method: 'post',
    data
  })
}

//修改状态
export function domainOpen(data) {
  return request({
    url: `api/wudaogang/domain/open`,
    method: 'post',
    data
  })
}

//获取未读条数
export function domainMsgCount(data) {
  return request({
    url: `api/wudaogang/domain/msgCount`,
    method: 'post',
    data
  })
}

//进入获取哪个机器的数据
export function domainMsgGetUrl(code) {
  return request({
    url: `api/wudaogang/domain/getUrl/${code}`,
    method: 'get',
  })
}